var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var AssemblyIf = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return concat(['if ', path.call(_print, 'condition'), ' ', path.call(_print, 'body')]);
  }
};
module.exports = AssemblyIf;